"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const fetch_adapter_1 = require("./fetch.adapter");
const resource_1 = require("./resource");
const url_join_1 = __importDefault(require("url-join"));
const parsers_1 = require("./parsers");
const library_parser_1 = require("./parsers/library.parser");
function isURL(str) {
    try {
        new URL(str);
        return true;
    }
    catch (_) {
        return false;
    }
}
function joinURL(baseURL, url) {
    return isURL(url) ? url : url_join_1.default(baseURL, url);
}
class Loader {
    constructor(options = {}) {
        this.queue = [];
        this.countLoading = 0;
        this.resources = {};
        this.options = Object.assign({
            adapter: new fetch_adapter_1.FetchAdapter(),
            concurently: 10,
            parsers: [new parsers_1.JsonParser(), new parsers_1.TextureParser(), new parsers_1.SpritesheetParser(), new library_parser_1.LibaryParser()],
        }, options);
        this.parsers.sort((a, b) => a.priority - b.priority);
    }
    get adapter() {
        return this.options.adapter;
    }
    get parsers() {
        return this.options.parsers;
    }
    addResource(name, url, options) {
        var _a;
        let resource = (_a = this.resources[name]) !== null && _a !== void 0 ? _a : new resource_1.LoaderResource({
            name,
            request: {
                method: 'GET',
                url: joinURL(this.options.baseURL, url),
            },
            options
        });
        if (!resource.in_queue) {
            this.resources[name] = resource;
            this.queue.push(resource);
            resource.in_queue = true;
            this.loadMore();
        }
        return resource;
    }
    addArray(resources) {
        const items = resources.map(item => {
            if (typeof item === 'string') {
                return this.addResource(item, item);
            }
            return this.addResource(item.name, item.url, item.options);
        });
        return {
            resources: items,
            wait: () => Promise.all(items.map(item => item.toPromise())),
            progress(cb) {
                let loaded = 0;
                items.forEach((res) => {
                    res.toPromise().finally(() => {
                        cb(loaded++, items.length);
                    });
                });
                return this;
            }
        };
    }
    addDic(resources) {
        return this.addArray(Object.entries(resources).map(([name, resource]) => ({
            name,
            url: resource,
            options: {}
        })));
    }
    add(resourceItem, url) {
        if (Array.isArray(resourceItem))
            return this.addArray(resourceItem);
        if (typeof resourceItem === 'object' && !resourceItem.name)
            return this.addDic(resourceItem);
        let name;
        if (typeof url === 'string') {
            name = resourceItem;
        }
        else if (typeof resourceItem === 'string') {
            name = url = resourceItem;
        }
        const resource = this.addResource(name, url);
        return {
            resource: resource,
            wait: () => resource.toPromise()
        };
    }
    loadMore() {
        if (this.countLoading >= this.options.concurently) {
            return;
        }
        const canLoadCount = Math.max(0, this.options.concurently - this.countLoading);
        const resources = this.queue.splice(0, canLoadCount);
        this.countLoading += resources.length;
        resources.forEach(resource => this.loadItem(resource));
    }
    hook(name, resource) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const middleware of this.parsers) {
                if (name in middleware) {
                    yield middleware[name](resource, this);
                }
            }
        });
    }
    loadItem(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hook('pre', resource);
            return this.adapter.request(resource.request)
                .then((res) => __awaiter(this, void 0, void 0, function* () {
                this.countLoading--;
                resource.response = res;
                resource.loaded = true;
                yield this.hook('use', resource);
                resource.ready = true;
                resource.emit('ready', resource);
            }))
                .catch(err => resource.emit('error', err))
                .finally(() => {
                resource.emit('load', resource);
                this.loadMore();
            });
        });
    }
    parse(parser, resource) {
        return __awaiter(this, void 0, void 0, function* () {
            const parseInstance = this.parsers[parser];
            if (parseInstance)
                yield parseInstance.parse(resource, this);
            return resource;
        });
    }
}
exports.Loader = Loader;
